import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import SortableCell from 'components/shared/Helpers/SortableCell'
import SortableHeaderCell from 'components/shared/Helpers/SortableHeaderCell'
import config from 'config/config.js'
import { I18n } from 'lib/i18n'
import { classNames, sort } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import {
  loadContactRequestsCSV,
  selectContactRequest,
} from 'redux/contactRequests'
import { Button, Icon, Segment, Table } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { contactRequestsLoading, contactRequests } = state.contactRequests
  return { contactRequestsLoading, contactRequests }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadContactRequestsCSV,
      selectContactRequest,
    },
    dispatch
  )
}

class ContactRequestBrowser extends React.Component {
  state = {
    sortCol: 'created_at',
    direction: 'descending',
  }

  sortBy(sortCol) {
    const { direction } = this.state

    this.setState({
      sortCol: sortCol,
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  getContactRequests() {
    const { sortCol, direction } = this.state
    const {
      match: {
        params: { contact_request_id },
      },
    } = this.props // withRouter
    const { contactRequests = [], selectContactRequest } = this.props // redux
    const { history } = this.props //router

    let sortedList = contactRequests
    if (sortCol && sortedList)
      sortedList = sortedList.sort((a, b) => sort(a, b, sortCol))
    if (direction !== 'ascending' && sortedList)
      sortedList = sortedList.reverse()

    return !sortedList
      ? false
      : sortedList.map((contactRequest, index) => (
          <Table.Row
            active={contactRequest.id === Number(contact_request_id)}
            key={index}
            className={contactRequest.read ? 'unobtrusive' : ''}
            onClick={(event) => {
              event.preventDefault()
              history.push(`${config.nodes.contactRequest}${contactRequest.id}`)
              selectContactRequest(contactRequest.id)
            }}>
            <SortableCell
              sort={sortCol}
              name="read"
              children={
                <Icon
                  {...(contactRequest.read
                    ? config.icons.mailRead
                    : config.icons.mailUnread)}
                />
              }
            />
            <SortableCell
              sort={sortCol}
              name="email"
              text={contactRequest.email}
            />
            <SortableCell
              sort={sortCol}
              name="created_at"
              text={new Date(contactRequest.created_at).toLocaleDateString(
                'de-CH',
                config.format.date
              )}
            />
          </Table.Row>
        ))
  }

  render() {
    const dark = config.theme.dark

    // redux props
    const { componentLoading, loadContactRequestsCSV } = this.props
    // local component state
    const { sortCol, direction } = this.state

    return componentLoading ? (
      <ComponentPlaceholder />
    ) : (
      <div
        className={classNames([
          'contactRequestBrowser',
          'hide-print',
          dark && 'inverted',
        ])}>
        <ComponentHeader
          title={I18n.t('admin.contact_requests.browser.title')}
          customAction={
            <Button
              color="blue"
              labelPosition="right"
              icon="cloud download"
              content=".CSV"
              onClick={(event) => {
                event.preventDefault()
                loadContactRequestsCSV()
              }}
            />
          }
        />

        <Segment
          attached
          className={classNames(['payload', 'clip', dark && 'inverted'])}>
          <Table
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Header>
              <Table.Row>
                <SortableHeaderCell
                  collapsing
                  name="read"
                  title={<Icon name="checkmark" color="grey" />}
                  onClick={() => this.sortBy('read')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  name="email"
                  title={I18n.t('admin.contact_requests.browser.sender')}
                  onClick={() => this.sortBy('email')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  collapsing
                  name="created_at"
                  title={I18n.t('admin.contact_requests.browser.date')}
                  onClick={() => this.sortBy('created_at')}
                  sortCol={sortCol}
                  direction={direction}
                />
              </Table.Row>
            </Table.Header>

            <Table.Body children={this.getContactRequests()} />
          </Table>
        </Segment>
      </div>
    )
  }
}

ContactRequestBrowser = connect(mapStateToProps, mapDispatchToProps)(
  ContactRequestBrowser
)
export default withRouter(ContactRequestBrowser)



// WEBPACK FOOTER //
// ./src/components/admin/ContactRequests/ContactRequestBrowser.jsx